/* Progressive enhancement: native scrolling works without JavaScript. */
(function () {
  'use strict';
  if (customElements.get('am-collection-rail')) return;
  class CollectionRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.anime-row');
      this.controls = this.querySelector('.collection-rail__controls');
      if (!this.track || !this.controls) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.update = this.update.bind(this);
      this.controls.addEventListener('click', (event) => {
        const button = event.target.closest('[data-rail-direction]');
        if (!button) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({
          left: Number(button.dataset.railDirection) * this.track.clientWidth * .8 * rtl,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }, options);
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      this.controls.hidden = max < 2;
      this.controls.querySelector('[data-rail-direction="-1"]').disabled = position < 2;
      this.controls.querySelector('[data-rail-direction="1"]').disabled = position >= max - 2;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  }
  customElements.define('am-collection-rail', CollectionRail);
})();
